import { Route, Link, BrowserRouter as Router } from "react-router-dom";
import React, { Component } from 'react';
import { connect } from 'react-redux';
import BlockedCardList from '../components/BlockedCardList';
import PinterestSearchBox from '../components/PinterestSearchBox';
import Navbar from 'react-bootstrap/Navbar';
import Nav from 'react-bootstrap/Nav';
import Container from 'react-bootstrap/Container';
import Spinner from 'react-bootstrap/Spinner';
import Alert from 'react-bootstrap/Alert';
import { FaSignOutAlt, FaUser, FaUsers, FaPlus, FaFlag } from "react-icons/fa";
import { setSearchField, requestRobots } from '../actions';
import env from "react-dotenv";

let BLOCKED_ACCOUNTS_URL = `${env.API_URL}/p10/blockedAccounts`;

const mapStateToProps = state => {
  return {
    searchField: state.searchRobots.searchField,
    robots: state.requestRobots.robots,
    ispending: state.requestRobots.ispending,
    error: state.requestRobots.error
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    onSearchChange: (event) => dispatch(setSearchField(event.target.value)),
    onRequestRobots: () => dispatch(requestRobots())
  }
}

class Reported extends Component {
  constructor() {
    super();
    
    const savedState = this.loadStateFromStorage();
    
    this.state = {
      route: 'reported',
      isSignedIn: savedState.isSignedIn || false,
      updateFlag: false,
      isLoading: true,
      error: null,
      user: savedState.user || {
        id: '',
        first_name: '',
        last_name: '',
        gender: '',
        email: '',
        joined: '',
        profile_image: '',
        rating: '',
        rating_count: '',
        image_key: '',
        administrator: ''
      },
      reportedProfiles: []
    }
    this.setStateApp = this.setStateApp.bind(this);
  }

  loadStateFromStorage() {
    try {
      const savedState = localStorage.getItem('p10-app-state');
      if (savedState) {
        return JSON.parse(savedState);
      }
    } catch (error) {
      console.error('Error loading state from storage:', error);
    }
    return {};
  }

  async setStateApp() {
    try {
      const response = await fetch(BLOCKED_ACCOUNTS_URL, {
        type: 'GET',
        contentType: 'application/json',
        headers: { Authorization: env.API_KEY }
      });

      if (!response.ok) {
        throw new Error('Failed to fetch reported profiles');
      }

      const users = await response.json();
      const usersArray = Array.isArray(users) ? users : [];

      this.setState({
        reportedProfiles: usersArray,
        error: null
      });

      return usersArray;
    } catch (error) {
      console.error('Error fetching reported profiles:', error);
      this.setState({
        error: 'Failed to load reported profiles. Please try again.',
        isLoading: false
      });
    }
  }

  async fetchReportedProfiles() {
    this.setState({ isLoading: true });

    try {
      await this.setStateApp();
      this.setState({ isLoading: false });
    } catch (error) {
      console.error('Error:', error);
      this.setState({
        error: 'Failed to load reported profiles.',
        isLoading: false
      });
    }
  }

  componentDidMount() {
    // Load user state from localStorage
    try {
      const savedState = localStorage.getItem('p10-app-state');
      if (savedState) {
        const parsed = JSON.parse(savedState);
        if (parsed.user && parsed.user.id) {
          this.setState({ user: parsed.user, isSignedIn: true });
        }
      }
    } catch (error) {
      console.error('Error loading state:', error);
    }

    this.fetchReportedProfiles();
    this.props.onRequestRobots();
    this.setState({ updateFlag: true });
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.updateFlag !== this.state.updateFlag && this.state.updateFlag === true) {
      this.fetchReportedProfiles();
      this.setState({ updateFlag: false });
    }
  }

  onRouteChange = (route) => {
    if (route === 'signout') {
      this.setState({ isSignedIn: false });
      localStorage.removeItem('p10-app-state');
    } else if (route === 'home') {
      this.setState({ isSignedIn: true, updateFlag: true });
    }
    this.setState({ route: route });
  }

  render() {
    const { isSignedIn, route, isLoading, error, user, reportedProfiles } = this.state;
    const { searchField, onSearchChange } = this.props;

    const reportedArray = Array.isArray(reportedProfiles) ? reportedProfiles : [];

    const filteredReports = reportedArray.filter(report => {
      return report && report.first_name &&
        report.first_name.toLowerCase().includes(searchField.toLowerCase());
    });

    return (
      <div style={{ backgroundColor: '#f8f9fa', minHeight: '100vh' }}>
        {/* Modern Top Navigation */}
        <Navbar expand="lg" fixed="top" bg="white" variant="light" style={{ boxShadow: '0 2px 4px rgba(0,0,0,0.1)' }}>
          <Container fluid style={{ maxWidth: '1800px' }}>
            <Navbar.Brand href="/home" style={{ display: 'flex', alignItems: 'center', marginRight: '20px' }}>
              <img src="/images/p10.jpg" alt="P10" style={{ height: '32px', width: '32px', marginRight: '8px', borderRadius: '8px' }} />
              <span style={{ fontWeight: '600', fontSize: '1.2rem', color: '#1f2937' }}>P10 Rating</span>
            </Navbar.Brand>

            <div style={{
              flex: '1',
              maxWidth: '900px',
              margin: '0 20px',
              display: window.innerWidth < 992 ? 'none' : 'block'
            }}>
              <PinterestSearchBox searchChange={onSearchChange} searchField={searchField} placeholder="Search reported profiles by name..." />
            </div>

            <Navbar.Toggle aria-controls="main-navbar" />
            <Navbar.Collapse id="main-navbar">
              <div style={{
                display: window.innerWidth >= 992 ? 'none' : 'block',
                padding: '10px 0'
              }}>
                <PinterestSearchBox searchChange={onSearchChange} searchField={searchField} placeholder="Search reported profiles by name..." />
              </div>

              <Nav className="ms-auto">
                <Link to={'/profile'} className="nav-link" style={{ fontWeight: '600' }}>
                  <FaUser style={{ marginRight: '6px' }} /> Profile
                </Link>
                <Link to={'/dimes'} className="nav-link" style={{ fontWeight: '600' }}>
                  <FaUsers style={{ marginRight: '6px' }} /> Dimes
                </Link>
                <Link to={'/userdimes'} className="nav-link" style={{ fontWeight: '600' }}>
                  <FaUsers style={{ marginRight: '6px' }} /> User Dimes
                </Link>
                <Link to={'/addDime'} className="nav-link" style={{ fontWeight: '600' }}>
                  <FaPlus style={{ marginRight: '6px' }} /> Add Dimes
                </Link>
                <Link to={'/reported'} className="nav-link" style={{ fontWeight: '600', color: '#e60023' }}>
                  <FaFlag style={{ marginRight: '6px' }} /> Reported
                </Link>
                <Link to={'/signin'} className="nav-link" style={{ fontWeight: '600' }}>
                  <FaSignOutAlt style={{ marginRight: '6px' }} /> Log out
                </Link>
              </Nav>
            </Navbar.Collapse>
          </Container>
        </Navbar>

        {/* Main Content */}
        <Container fluid style={{ paddingTop: '100px', paddingBottom: '100px', maxWidth: '1400px' }}>
          <div className="tc">
            {/* Header */}
            <h1 style={{ fontSize: '2.5rem', fontWeight: '700', color: '#1f2937', marginBottom: '10px' }}>
              Reported Accounts
            </h1>
            <h2 style={{ fontSize: '1.5rem', color: '#6b7280', marginBottom: '40px' }}>
              Review and Manage Reported Profiles
            </h2>

            {/* Error Alert */}
            {error && (
              <Alert variant="danger" dismissible onClose={() => this.setState({ error: null })}>
                {error}
              </Alert>
            )}

            {/* Loading Spinner */}
            {isLoading ? (
              <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '400px' }}>
                <Spinner animation="border" role="status" variant="primary">
                  <span className="sr-only">Loading...</span>
                </Spinner>
              </div>
            ) : (
              <>
                {/* No Results Message */}
                {filteredReports.length === 0 && !isLoading && (
                  <div style={{ textAlign: 'center', padding: '80px 20px' }}>
                    <h2 style={{ color: '#6b7280', marginBottom: '10px' }}>No reported profiles found</h2>
                    <p style={{ color: '#9ca3af' }}>Try adjusting your search or refresh the page</p>
                  </div>
                )}

                {/* Grid Layout - Same as Main.js */}
                {filteredReports.length > 0 && (
                  <div style={{
                    display: 'grid',
                    gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))',
                    gap: '24px',
                    padding: '20px'
                  }}>
                    {filteredReports.map((report, index) => (
                      <div key={index}>
                        <BlockedCardList
                          setTest={this.setStateApp}
                          robots={[report]}
                        />
                      </div>
                    ))}
                  </div>
                )}
              </>
            )}
          </div>
        </Container>

        {/* Modern Footer */}
        <div style={{
          backgroundColor: 'white',
          borderTop: '1px solid #e5e7eb',
          padding: '20px 0',
          position: 'fixed',
          bottom: 0,
          width: '100%',
          boxShadow: '0 -2px 4px rgba(0,0,0,0.05)'
        }}>
          <Container>
            <div style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              flexWrap: 'wrap',
              gap: '20px',
              fontSize: '0.9rem'
            }}>
              <span style={{ color: '#6b7280' }}>© 2026 p10rating</span>
              <Link to="/privacypolicy" style={{ color: '#3b82f6', textDecoration: 'none' }}>Privacy</Link>
              <Link to="/disclaimer" style={{ color: '#3b82f6', textDecoration: 'none' }}>Disclaimer</Link>
              <Link to="/terms" style={{ color: '#3b82f6', textDecoration: 'none' }}>Terms</Link>
            </div>
          </Container>
        </div>
      </div>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Reported);